import { Component, OnInit, ViewChild, ElementRef, setTestabilityGetter } from '@angular/core';
import { IomCreateproposal } from '../../../models/iom-createproposal';
import { MasterEditProposal } from 'src/app/models/master-editproposal';
import { HttpErrorResponse } from '@angular/common/http';
import { IomService } from 'src/app/services/iom.service';
import { SessionService } from '../../../services/session.service'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { find, get, pull } from 'lodash';
import { Router, ActivatedRoute } from '@angular/router'
import { MessageService } from 'src/app/services/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfigService } from 'src/app/services/app-config.service';
declare var bootbox: any;
declare var $: any;

@Component({
  selector: 'app-edit-diy-proposal',
  templateUrl: './edit-diy-proposal.component.html',
  styleUrls: ['./edit-diy-proposal.component.css']
})
export class EditDiyProposalComponent implements OnInit {

  [x: string]: any;
  enableBox = false;

  @ViewChild('tagInput') tagInputRef: ElementRef;
  tags: string[] = [];
  form1: FormGroup;
  DistinctClientList: any;
  proposal: { Market: { MarketName: string, MarketId: number }[], MarketUnit: { MarketUnitId: number, MarketUnitName: string, Market: string }[], ClientGroup: { ClientGroupId: number, ClientGroupName: string }[], ProposalDetail: IomCreateproposal[] };
  MasterProposal: MasterEditProposal[];
  clientList: IomCreateproposal;
  IOMS: IomCreateproposal;
  ClientName: string;
  clientGroup: String;
  market: String;
  ProjectName: String;
  marketUnit: String;
  opportunityId: String;
  proposalId: any;
  userAccess: String;
  createdBy: String;
  title: String;
  proposalData: IomCreateproposal;
  marketList: { MarketName: string, MarketId: number }[];
  marketUnitList: { MarketUnitId: number, MarketUnitName: string, Market: string }[];
  ClientGroupList: { ClientGroupId: number, ClientGroupName: string }[];
  ProposalDetailList: IomCreateproposal[];
  ProjectDetails: String[];
  MasterProjectDetails: any;
  MasterMarketList: any;
  MasterMarketUnitList: any;
  MasterClientGroupList: any;
  MasterFilteredMarketUnitList: any;
  filteredMarketUnitList: { MarketUnitId: number, MarketUnitName: string, Market: string }[];
  userType: number;
  clientId: string;
  marketDetail: any;
  constructor(private spinner: NgxSpinnerService, private iomservice: IomService, private messageService: MessageService, private sessionservice: SessionService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private appConfigService: AppConfigService) {
    var data = this.appConfigService.getEnvironment();
    this.instanceType = data.instanceType;
  }
  isEdit: boolean = false;
  isMandateCreate = false;
  Noaccess: boolean = true;
  subscribed: boolean = true;
  ngOnInit() {
    $('#standScope').hide();
    $('#standaloneScope').hide();
    this.createdBy = this.sessionservice.getUserName();
    this.form1 = this.fb.group({
      tag: [undefined],
    });
    // this.getMasterClientDetails("");
    // var x = this.router.url.toLocaleLowerCase();//get the url
    // if (x != null && x != "" && x != undefined) {
    //   if (x.includes('e2euid') || x.includes('cmsuid') || x.includes('wsuid')) {
    //     this.sessionservice.setSessionStorageItem("userType", "3");
    //     //redirect to dd creen
    //     this.router.navigate(['deepdive'], { queryParams: { "E2EUId": this.sessionservice.getE2EUId(), "CMSUId": this.sessionservice.getCMSUId(), "WSUId": this.sessionservice.getWSUId() } });
    //   }
    //   else if (x.includes('solutionid')) {
    //     this.sessionservice.setSessionStorageItem("userType", "4");
    //     this.router.navigate(['deepdive'], { queryParams: { "SolutionId": this.sessionservice.getSolutionId() } });
    //   }
    //   else {
    //    // this.sessionservice.setSessionStorageItem("userType", "1"); //for FDS
    //   }
    // }
    //this.messageService.currentMandatCreateProposal.subscribe(x=> this.isMandateCreate = x);
    if (this.router.url.startsWith('/editdiyproposal')) {
      this.isEdit = false;
      this.isMandateCreate = true;
      this.getMasterClientDetails("");
    }
    this.userType = parseInt(this.sessionservice.getSessionStorageItem("userType"));
    if (this.userType == 1) {
      if (this.router.url.startsWith('/editproposal')) {
        this.route.paramMap.subscribe(params => {
          let proposalId = params.get('proposalId');
          this.GetProposalDataById(proposalId);
          this.isEdit = true;
          this.isMandateCreate = false;
        });
      }
      else if (this.router.url.startsWith('/createproposal/create')) {
        this.isEdit = false;
        this.isMandateCreate = true;
        this.GetProData();

      }
      else {
        this.isEdit = false;
        this.GetProData();
        this.isMandateCreate = false;
      }
    }
    else if (this.userType == 3) {
      //this.router.navigate(['deepdive'], { queryParams: { "E2EUId": this.sessionservice.getE2EUId(), "CMSUId": this.sessionservice.getCMSUId(), "WSUId": this.sessionservice.getWSUId() } });
      if (this.router.url.startsWith('/editproposal')) {
        this.route.queryParams.subscribe(params => {
          let E2EUID = this.iomservice.GetValueFromQueryParams(params, "E2EUID");
          if (E2EUID != '' && E2EUID != undefined) {
            this.GetProposalDataById(E2EUID);
            this.isEdit = true;
            this.isMandateCreate = true;
          }
          else {
            this.propId = this.sessionservice.getE2EUId();
            this.GetProposalDataById(this.propId);
            this.isEdit = true;
            this.isMandateCreate = true;
          }
        });
      }
    }
    else {
      // mysp flow
      this.router.navigate(['deepdive'], { queryParams: { "SolutionId": this.sessionservice.getSolutionId() } });
    }

    if (this.instanceType == "FDS") {
      this.Noaccess = true;
    }
    else {
      this.Noaccess = false;
    }

    this.form1 = this.fb.group({
      tag: [undefined],
    });
    this.getEditDetails();
  }

  GetMarketunit() {
    this.marketUnit = "Select";
    this.filteredMarketUnitList = this.marketUnitList.filter(x => x.Market == this.market);
  }

  getEditDetails() {
    this.iomservice.getProp<any>(this.sessionservice.getUserName(), "").subscribe(data => {
      this.editdata = data;
    })
  }

  showHeaderB() {
    if (this.router.url.startsWith('/editproposal')) {
      return true;
    } else { return false; }
  }

  hideCreateProp() {
    if (this.router.url.startsWith('/createdeepdive')) {
      return true;
    } else { return false; }
  }

  Validate(): boolean {
    if (!this.clientName) {
      bootbox.alert("Please select the valid client name");
      return false;
    }
    else if (!this.projectName) {
      bootbox.alert("Please select the valid e2e name");
      return false;
    }
    // else if (!this.opportunityId) {
    //   bootbox.alert("Please enter the valid market");
    //   return false;
    // }
    // else if (!this.market || this.market == "Select") {
    //   bootbox.alert("Please select the valid market");
    //   return false;
    // }
    // else if (!this.marketUnit || this.marketUnit == "Select") {
    //   bootbox.alert("Please select the valid market unit");
    //   return false;
    // }
    // else if (!this.clientGroup || this.clientGroup == "Select") {
    //   bootbox.alert("Please select the valid client group");
    //   return false;
    // }
    else {
      return true;
    }
  }

  CreateProposal() {
    let that = this;
    let isExist = false;
    if (this.Validate()) {
      this.spinner.show();
      if (!this.isEdit) {
        // oppData = this.ProposalDetailList.find(x => (x.ClientName.toLowerCase() == this.clientName.toLowerCase() && x.ProjectName.toLowerCase() == this.projectName.toLowerCase() && x.ProposalName.toLowerCase() == this.opportunityId.toLowerCase()));
        //if (oppData) {
        //  isExist = true;
        //}
        //else {
        isExist = false;
        //}
      }
      else {
        isExist = false;
      }
      if (isExist) {
        this.spinner.hide();
        bootbox.alert("The OpportunityId already exist");
        // return false;
      }
      else {
        // this.iomservice.getEditDetails<any>(this.sessionservice.getUserName(), this.proposalId, this.tags.join()).subscribe(data => {
          this.iomservice.createProp<any>(this.clientName, this.clientGroup, this.market, this.projectName, this.marketUnit, this.opportunityId, 0, this.proposalId, this.tags.join(), this.createdBy).subscribe(data => {
          //console.log(data);        
          this.spinner.hide();
          if (data.Result == "Success") {
            bootbox.alert("Proposal created successfully", function () {
            that.navigateToProposalSummary();
              });  
          }
          else {
            this.spinner.hide();
            bootbox.alert("Proposal creation failed");
          }
        },
          (err: HttpErrorResponse) => {
            console.log("Error Occured !");
            this.spinner.hide();
            bootbox.alert("Proposal creation failed");
          });
      }
    }
  }

  GetProData() {    
    this.spinner.show();
    this.iomservice.getProp<any>(this.sessionservice.getUserName(), "").subscribe(data => {
      this.spinner.hide();
      //console.log(data);     
      this.proposal = data;
      // if(this.proposal.IsSubScriptionOwner == 1){
      //   this.subscribed == true; 
      // }
      //   else {
      //     this.subscribed == false;
      // }
      this.marketList = this.proposal.Market;
      this.marketUnitList = this.proposal.MarketUnit;
      this.filteredMarketUnitList = [];
      this.ClientGroupList = this.proposal.ClientGroup;
      this.ProposalDetailList = this.proposal.ProposalDetail;
      this.DistinctClientList = [...new Set(this.proposal.ProposalDetail.map(x => x.ClientName))];
      this.marketUnit = "Select";
      this.market = "Select";
      this.clientGroup = "Select";
      if (this.router.url.startsWith('/createproposal/create')) {
        this.route.paramMap.subscribe(params => {
          let clientName = params.get('clients');
          this.GetProposalDataById(clientName);
          this.ClientName = this.ClientName;
        })
      }
      if (this.proposal.ProposalDetail.length > 0) {
        if (!this.isMandateCreate) {
          this.navigateToProposalSummary();
        }
      }
    },
      (err: HttpErrorResponse) => {
        console.log("Error Occured !");
        this.spinner.hide();
      });
  }

  getMasterClientDetails(clientId: any) {
    this.iomservice.GetMasterClientDetails<any>(clientId).subscribe(data => {
      this.MasterProposal = data;
      // if(this.proposal.IsSubScriptionOwner == 1){
      //   this.subscribed == true; 
      // }
      //   else {
      //     this.subscribed == false;
      // }
      this.proposalId = clientId;
      // this.marketList = this.MasterProposal.Market;
      // this.marketUnitList = this.MasterProposal.MarketUnit;
      // this.filteredMarketUnitList = [];
      // this.ClientGroupList = this.MasterProposal.ClientGroup;
      // this.ProposalDetailList = this.MasterProposal.ProposalDetail;
      // this.MasterProposalDetailList=this.MasterProposal;

      // this.MasterProposalDetailList= [...new Set(this.MasterProposal.map(x => x.EndToEnd))];
      this.DistinctClientList = [...new Set(this.MasterProposal.map(x => x.MasterClient.trim()))];
      // this.marketUnit = "Select";
      // this.market = "Select";
      // this.clientGroup = "Select";
    },
      (err: HttpErrorResponse) => {
        console.log("Error Occured !");
        this.spinner.hide();
      });
  }



  GetProposalDataById(proposalId: any) {
    this.iomservice.getProp<any>(this.sessionservice.getUserName(), proposalId).subscribe(data => {
      this.proposal = data;
      this.marketUnitList = this.proposal.MarketUnit;
      this.marketList = this.proposal.Market;
      this.ClientGroupList = this.proposal.ClientGroup;
      this.clientList = this.proposal.ProposalDetail.find(x => x.ProposalId == proposalId);
      if (this.clientList) {
        this.clientName = this.clientList.ClientName;
        this.clientGroup = this.clientList.ClientGroup ? this.clientList.ClientGroup : "Select";
        this.market = this.clientList.Market ? this.clientList.Market : "Select";
        this.projectName = this.clientList.ProjectName;
        this.marketUnit = this.clientList.MarketUnit ? this.clientList.MarketUnit : "Select";
        //this.filteredMarketUnitList = this.marketUnitList.filter(x => x.Market == this.market);
        this.opportunityId = this.clientList.ProposalName;
        this.proposalName = this.clientList.ProposalName;
        this.proposalId = this.clientList.ProposalId;
        if (this.clientList.IsSubScriptionOwner == 1) {
          this.subscribed = true;
        }
        else {
          this.subscribed = false;
        }
        this.userAccess = this.clientList.UserAccess;
        if (this.userAccess) {
          let userNames = this.userAccess.split(',');
          userNames.forEach(element => {
            this.addTag(element)
          });
        }
        this.createdBy = this.clientList.CreatedByUser;
      }
    },
      (err: HttpErrorResponse) => {
        console.log("Error Occured !");
      });
  }

  //tags
  focusTagInput(): void {
    this.tagInputRef.nativeElement.focus();
  }
  onKeyUp(event: KeyboardEvent): void {
    const inputValue: string = this.form1.controls.tag.value;
    // if (event.code === 'Backspace' && !inputValue) {
    //   this.removeTag();
    //   return;
    // } else {
    if (event.code === 'Comma' || event.code === 'Enter') {
      this.addTag(inputValue);
      this.form1.controls.tag.setValue('');
    }
    //}
  }
  addTag(tag: string): void {
    if (tag) { tag = tag.trim().toLowerCase(); }
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if (tag != 'hpdp.user04' && (/^[a-zA-Z.]*$/.test(tag)) == false) {
      bootbox.alert("UserName should not contain numerics & special characters!")
    }
    else if (($.inArray(tag, this.tags) >= 0)) {
      bootbox.alert("\"" + tag + "\" already exists");
    }
    else if (tag.length > 0) {
      this.tags.push(tag);
      this.enableBox = true;
    }
  }
  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this.tags, tag);
    } else {
      this.tags.splice(0, -1);
    }
    if (this.tags.length == 0) {
      this.enableBox = false;
    }
  }
  loadProjectDetails(ddname: string) {
    this.validate_dd(ddname);
    this.projectName = "";
    var data = this.MasterProposal.filter(x => x.MasterClient.trim() == this.clientName.trim());
    this.MasterProjectDetails = [...new Set(data.map(x => x.EndToEnd,))];
    this.projectName = this.MasterProjectDetails[0];
    var data = this.MasterProposal.filter(x => x.EndToEnd == this.projectName);
    this.MasterMarketList = [...new Set(data.map(x => x.Market))];
    this.market = this.MasterMarketList[0];
    var data = this.MasterProposal.filter(x => x.Market == this.market);
    this.MasterMarketUnitList = [...new Set(data.map(x => x.MarketUnit))];
    this.marketUnit = this.MasterMarketUnitList[0];
    var data = this.MasterProposal.filter(x => x.MarketUnit == this.marketUnit);
    this.MasterClientGroupList = [...new Set(data.map(x => x.ClientGroup))];
    this.clientGroup = this.MasterClientGroupList[0];
    // var data = this.ProposalDetailList.filter(x => x.ClientName == this.clientName);
    // this.ProjectDetails = [...new Set(data.map(x => x.ProjectName))];
  }
  loadMarketDetails(ddname: string) {
    this.validate_dd(ddname);
    this.market = "";
    var data = this.MasterProposal.filter(x => x.EndToEnd == this.projectName);
    this.MasterMarketList = [...new Set(data.map(x => x.Market))];
    this.market = this.MasterMarketList[0];
  }
  loadMarketUnitDetails(ddname: string) {
    this.validate_dd(ddname);
    this.marketUnit = "";
    var data = this.MasterProposal.filter(x => x.Market == this.market);
    this.MasterMarketUnitList = [...new Set(data.map(x => x.MarketUnit))];
    this.marketUnit = this.MasterMarketUnitList[0];
  }
  loadClientGroup(ddname: string) {
    this.validate_dd(ddname);
    this.clientGroup = "";
    var data = this.MasterProposal.filter(x => x.MarketUnit == this.marketUnit);
    this.MasterClientGroupList = [...new Set(data.map(x => x.ClientGroup))];
    this.clientGroup = this.MasterClientGroupList[0];
  }
  loadNothing(ddname: string) {
    this.validate_dd(ddname);
  }
  validate_dd(ddname) {
    var ddmodelvalue = this.get_ddmodel(ddname)
    if (this.is_valid_datalist_value(ddname, ddmodelvalue)) {
    } else {
      this.resetDD(ddname);
      return false;
    }
  }
  get_ddmodel(ddname) {
    let modelValue;
    switch (ddname) {
      case 'cname': {
        modelValue = this.clientName;
        break;
      }
      case 'pname': {
        modelValue = this.projectName;
        break;
      }
      case 'mname': {
        modelValue = this.market;
        break;
      }
      case 'muname': {
        modelValue = this.marketUnit;
        break;
      }
      case 'cgname': {
        modelValue = this.clientGroup;
        break;
      }
      default: {
        //statements; 
        break;
      }
    }
    return modelValue;
  }
  resetDD(ddname) {
    switch (ddname) {
      case 'cname': {
        bootbox.alert("Please select the valid client name");
        this.clientName = "";
        this.projectName = "";
        this.market = "";
        this.marketUnit = "";
        this.clientGroup = "";
        break;
      }
      case 'pname': {
        bootbox.alert("Please select the valid e2e name");
        this.projectName = "";
        this.market = "";
        this.marketUnit = "";
        this.clientGroup = "";
        break;
      }
      case 'mname': {
        bootbox.alert("Please select the valid market");
        this.market = "";
        this.marketUnit = "";
        this.clientGroup = "";
        break;
      }
      case 'muname': {
        bootbox.alert("Please select the valid market unit");
        this.marketUnit = "";
        this.clientGroup = "";
        break;
      }
      case 'cgname': {
        bootbox.alert("Please select the valid client group");
        this.clientGroup = "";
        break;
      }
      default: {
        //statements; 
        break;
      }
    }
  }
  is_valid_datalist_value(idDataList, inputValue) {
    var option = document.querySelector("#" + idDataList + " option[value='" + inputValue + "']");
    if (option != null) {
      return option.nodeName.length > 0;
    }
    return false;
  }
  navigateToProposalSummary() {
    this.router.navigate(['proposalsummary']);
  }
}
